class MailOrderPharmaciesController {
  /* @ngInject */
  constructor($log, $interval, Endpoints, MailOrderPharmacies, MedicationPrice, Business, Services, Auth, toastr) {
    Object.assign(this, {
      $log,
      $interval,
      Endpoints,
      MailOrderPharmacies,
      MedicationPrice,
      Business,
      Services,
      Auth,
      toastr,
      results: [],
      states: [],
      selected_states: [],
      services: [],
      selected_services: [],
      pharmacies: [],
      selected_pharmacies: [],
      selected_pharmacies_for_insert: [],
      selected_services_medications: {},
      selected_services_medications_for_insert: [],
      selected_medications: [],
      all_medications_added: false,
      started_selecting_medications: false,
      medications: [],
      allSelected: false,
      processing: false,
      currentlyAdding: false,
      insertInfo: null,
      readyToInsert: false,
      num_to_process: 0,
      payload: []
    });
    this.getAllStates();
    this.getAllPharmacies();
    this.getAllServices();
  }

  getAllStates() {
    this.Business.getAllStates().then(({
      data
    }) => {
      data.forEach(state => {
        state.code_and_name = state.code + ' - ' + state.state;
      });
      this.states = angular.copy(data);
      this.states_for_insert = angular.copy(data);
      this.states_for_multiple_insert = angular.copy(data);
      var elem = {
        "id": 0,
        "code": "SELECT",
        "supported": 1,
        "slv": 1,
        "slv_enabled": 1,
        "state": "Select a state",
        "code_and_name": "Select a state"
      };
      this.states.unshift(elem);
      this.states_for_insert.unshift(elem);
      this.selectedState = "SELECT";
      this.selectedState_for_insert = "SELECT";
    }).catch(err => {
      this.states = [];
      this.toastr.error('Error getting all states: ' + JSON.stringify(err));
    });
  }

  getAllPharmacies() {
    this.MailOrderPharmacies.getAllPharmacies().then(({
      data
    }) => {
      data.forEach(pharmacy => {
        pharmacy.id = pharmacy.pharmacy_id;
        pharmacy.id_string = "" + pharmacy.pharmacy_id;
        pharmacy.code_and_name = pharmacy.pharmacy_id + ' - ' + pharmacy.name;
        this.selected_pharmacies_for_insert.push(pharmacy);
      });
      this.pharmacies = data;
      var elem = {
        id: 0,
        "id_string": "0",
        "name": "Select a pharmacy",
        "code_and_name": "Select a pharmacy"
      };
      this.pharmacies.unshift(elem);
      this.selectedPharmacy = this.pharmacies[0];
    }).catch(err => {
      this.pharmacies = [];
      this.toastr.error('Error getting all pharmacies: ' + JSON.stringify(err));
    });
  }

  getAllServices() {
    this.Services.list().then(({
      data
    }) => {
      let servicesArr = [];

      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].children) {
          for (let j = 0; j < data.data[i].children.length; j++) {
            // console.log(data.data[i].children[j]);
            var code_and_name = data.data[i].children[j].code + ' - ' + data.data[i].children[j].name;
            servicesArr.push({
              id: data.data[i].children[j].id,
              code_and_name: code_and_name,
              code: data.data[i].children[j].code,
              name: data.data[i].children[j].name + " (" + data.data[i].children[j].code + ")"
            });
          }

          continue;
        }

        var code_and_name = data.data[i].code + ' - ' + data.data[i].name;
        servicesArr.push({
          id: data.data[i].id,
          code_and_name: code_and_name,
          code: data.data[i].code,
          name: data.data[i].name + " (" + data.data[i].code + ")"
        });
      }

      servicesArr.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
      this.services = angular.copy(servicesArr);
      this.services_for_insert = angular.copy(servicesArr);
      this.services_for_multiple_insert = angular.copy(servicesArr);
      var elem = {
        "id": 0,
        "code": "optional",
        "supported": 1,
        "slv": 1,
        "slv_enabled": 1,
        "name": "All Services",
        "code_and_name": "All Services"
      };
      this.services.unshift(elem);
      var elem_for_insert = {
        "id": 0,
        "code": "optional",
        "supported": 1,
        "slv": 1,
        "slv_enabled": 1,
        "name": "Select a service",
        "code_and_name": "Select a service"
      };
      this.services_for_insert.unshift(elem_for_insert);
      this.selectedService = "optional";
      this.selectedService_for_insert = "optional";
    }).catch(err => {
      this.services = [];
      this.services_for_insert = [];
      this.toastr.error('Error getting all services: ' + JSON.stringify(err));
    });
  }

  getByState() {
    this.selectedService = 'optional'; // FOR INSERT:
    // LIST OF SERVICES DOES NOT DEPEND OF STATE SELECTION
    // SO WE ALWAYS SHOW THE LIST OF SERVICES
    //
    // this.selectedService_for_insert = 'optional';

    this.MailOrderPharmacies.getByState(this.selectedState).then(({
      data
    }) => {
      data.forEach(row => {
        row.selected = false;
        row.successfulUpdate = '';
        row.old_pharmacy_id = row.pharmacy_id;
      });
      this.results = data;
      this.checkInfo();
    }).catch(err => {
      this.results = [];
      this.toastr.error('Error getting medications by state: ' + JSON.stringify(err));
    });
  }

  checkItems() {
    if (this.selected_states.length > 0 && this.selected_medications.length > 0 && this.selected_pharmacies.length > 0) {
      this.readyToInsert = true;
    }
  }

  clearSelectedMedications() {
    this.selected_medications = [];
    this.all_medications_added = false;
    this.started_selecting_medications = false;
  }

  clearSelectedServices() {
    this.all_medications_added = false;
    this.started_selecting_medications = false;
    this.selected_services = [];
    this.selected_services_medications_for_insert = [];
  }

  getAllMedications() {
    let services_length = this.services_for_multiple_insert.length - 1;
    this.started_selecting_medications = true;
    this.services_for_multiple_insert.forEach((service, i) => {
      if (!this.selected_services_medications.hasOwnProperty(service.code)) {
        this.MailOrderPharmacies.listMedicationsByService(service.code).then(({
          data
        }) => {
          let medlist = [];
          data.forEach(med => {
            med.medication_id_as_string = med.medication_id.toString();
            med.code_and_name = med.medication_id + ' - ' + med.medication_name;
            medlist.push(med);

            if (!this.selected_services_medications_for_insert.includes(med)) {
              this.selected_services_medications_for_insert.push(med);
            }
          });
          this.selected_services_medications_for_insert = Array.from(new Set(this.selected_services_medications_for_insert.map(a => a.medication_id))).map(id => {
            return this.selected_services_medications_for_insert.find(a => a.medication_id === id);
          });
          this.selected_services_medications[service.code] = {
            is_active: true,
            medications: medlist
          };

          if (i == services_length) {
            this.all_medications_added = true;
            this.checkItems();
          }
        }).catch(err => {
          this.medications = [];

          if (err && err.data && err.data.error && err.data.error.message) {
            this.toastr.error('Error: ' + err.data.error.message);
          } else {
            this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
          }
        });
      } else {
        this.selected_services_medications[service.code].is_active = true;
        this.selected_services_medications[service.code].medications.forEach(med => {
          if (!this.selected_services_medications_for_insert.includes(med)) {
            this.selected_services_medications_for_insert.push(med);
          }
        });
        this.selected_services_medications_for_insert = Array.from(new Set(this.selected_services_medications_for_insert.map(a => a.medication_id))).map(id => {
          return this.selected_services_medications_for_insert.find(a => a.medication_id === id);
        });

        if (i == services_length) {
          this.all_medications_added = true;
          this.checkItems();
        }
      }
    });
  }

  getMedications() {
    let services_length = this.selected_services.length - 1;
    this.started_selecting_medications = true;
    this.selected_services_medications_for_insert = [];
    Object.keys(this.selected_services_medications).forEach(service => {
      this.selected_services_medications[service].is_active = false;
    });
    this.selected_services.forEach((service, i) => {
      if (!this.selected_services_medications.hasOwnProperty(service.code)) {
        this.MailOrderPharmacies.listMedicationsByService(service.code).then(({
          data
        }) => {
          let medlist = [];
          data.forEach(med => {
            med.medication_id_as_string = med.medication_id.toString();
            med.code_and_name = med.medication_id + ' - ' + med.medication_name;
            medlist.push(med);

            if (!this.selected_services_medications_for_insert.includes(med)) {
              this.selected_services_medications_for_insert.push(med);
            }
          });
          this.selected_services_medications_for_insert = Array.from(new Set(this.selected_services_medications_for_insert.map(a => a.medication_id))).map(id => {
            return this.selected_services_medications_for_insert.find(a => a.medication_id === id);
          });
          this.selected_services_medications[service.code] = {
            is_active: true,
            medications: medlist
          };

          if (i == services_length) {
            this.all_medications_added = true;
            this.checkItems();
          }
        }).catch(err => {
          this.medications = [];

          if (err && err.data && err.data.error && err.data.error.message) {
            this.toastr.error('Error: ' + err.data.error.message);
          } else {
            this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
          }
        });
      } else {
        this.selected_services_medications[service.code].is_active = true;
        this.selected_services_medications[service.code].medications.forEach(med => {
          if (!this.selected_services_medications_for_insert.includes(med)) {
            this.selected_services_medications_for_insert.push(med);
          }
        });
        this.selected_services_medications_for_insert = Array.from(new Set(this.selected_services_medications_for_insert.map(a => a.medication_id))).map(id => {
          return this.selected_services_medications_for_insert.find(a => a.medication_id === id);
        });

        if (i == services_length) {
          this.all_medications_added = true;
          this.checkItems();
        }
      }
    });
  }

  getMedicationsByService() {
    this.MailOrderPharmacies.listMedicationsByService(this.selectedService_for_insert).then(({
      data
    }) => {
      let medlist = [];
      data.forEach(med => {
        med.medication_id_as_string = med.medication_id.toString();
        med.code_and_name = med.medication_id + ' - ' + med.medication_name;
        medlist.push(med);
      });
      this.medications = medlist;
      if (this.medications && this.medications.length) this.currentMedication = this.medications[0].medication_id_as_string;
      this.checkInfo();
    }).catch(err => {
      this.medications = [];

      if (err && err.data && err.data.error && err.data.error.message) {
        this.toastr.error('Error: ' + err.data.error.message);
      } else {
        this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
      }
    });
  }

  getByService() {
    if (this.selectedService === 'optional') {
      this.getByState();
    } else {
      this.MailOrderPharmacies.getByService(this.selectedState, this.selectedService).then(({
        data
      }) => {
        data.forEach(row => {
          row.selected = false;
          row.successfulUpdate = '';
          row.old_pharmacy_id = row.pharmacy_id;
        });
        this.results = data;
      }).catch(err => {
        this.results = [];
        this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
      });
    }
  }

  select(row) {
    if (!row['selected']) {
      row['selected'] = true;
    } else {
      row['selected'] = false;
    }

    this.num_to_process = 0;
    this.filteredResults.forEach(result => {
      if (result['selected']) this.num_to_process++;
    });

    if (this.filteredResults.length && this.num_to_process === this.filteredResults.length) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
  }

  selectAll() {
    if (!this.allSelected) {
      this.filteredResults.forEach(result => {
        result['selected'] = true;
      });
      this.allSelected = true;
      this.num_to_process = this.filteredResults.length;
    } else {
      this.filteredResults.forEach(result => {
        result['selected'] = false;
      });
      this.allSelected = false;
      this.num_to_process = 0;
    }
  }

  checkFinish() {
    if (this.num_processed >= this.num_to_process) {
      if (this.poll) this.$interval.cancel(this.poll);
      this.processing = false;
    }
  }

  addMedication() {
    this.currentlyAdding = true;
  }

  cancelAddMedication() {
    this.currentlyAdding = false; // this.insertInfo = null;
    // this.selectedState = 'SELECT';
  }

  checkInfo() {
    var now = new Date().getTime();
    var timestamp = parseInt(now / 1000);
    this.insertInfo = {
      state_code: this.selectedState_for_insert,
      pharmacy_id: this.selectedPharmacy.pharmacy_id,
      medication_id: Number(this.currentMedication),
      created: timestamp
    };

    if (this.selectedState_for_insert === 'SELECT' || this.selectedService_for_insert === 'optional' || !this.currentMedication || this.selectedPharmacy.id_string === "0") {
      this.readyToInsert = false;
    } else {
      this.readyToInsert = true;
    }
  }

  formatBulkAdd() {
    this.payload = [];
    this.selected_states.sort((a, b) => a.code > b.code ? 1 : -1);
    this.selected_medications.sort((a, b) => a.medication_id > b.medication_id ? 1 : -1);
    this.selected_pharmacies.forEach(pharmacy => {
      this.selected_medications.forEach(medication => {
        this.selected_states.forEach(state => {
          this.payload.push({
            medication_id: medication.medication_id,
            state_code: state.code,
            pharmacy_id: pharmacy.id
          });
        });
      });
    });
  }

  bulkInsert() {
    this.formatBulkAdd();
    this.MailOrderPharmacies.bulkAdd(this.payload).then(() => {
      this.payload = [];
      this.currentlyAdding = false;
      this.toastr.success('Medications added successfully');
    }).catch(err => {
      this.payload = [];

      if (err && err.data && err.data.code == 401 || err.data.code == 403) {
        this.toastr.error('Error: ' + 'You are not authorized to make this change.');
      } else if (err && err.data && err.data.error_message) {
        this.toastr.error('Error: ' + err.data.error_message);
      } else {
        this.toastr.error('Error: ' + JSON.stringify(err));
      }
    });
  }

  insert() {
    let audit = {};
    audit.user_id = this.Auth.profile.id;
    audit.action_cd = 'INSERT';
    audit.medication_id = this.insertInfo.medication_id;
    audit.pharmacy_id = this.insertInfo.pharmacy_id;
    audit.field = 'pharmacy_id';
    audit.state_code = this.insertInfo.state_code;
    audit.was = 'NULL';
    audit.now = this.insertInfo.pharmacy_id; // audit.timestamp = Date.now();

    var now = new Date().getTime();
    audit.timestamp = parseInt(now / 1000);
    this.MailOrderPharmacies.insert(this.insertInfo.medication_id, this.insertInfo.state_code, this.insertInfo.pharmacy_id, this.insertInfo.created).then(() => {
      this.MailOrderPharmacies.audit(audit).then(() => {
        this.currentlyAdding = false;
        this.toastr.success('Pharmacy added successfully');
      }).catch(err => {
        this.toastr.error('Error auditing pharmacy: ' + JSON.stringify(err));
      });
    }).catch(err => {
      if (err && err.data && err.data.error && err.data.error.code && err.data.error.code === "ER_DUP_ENTRY") {
        // Duplicate entry
        this.toastr.error('Pharmacy found for the same state and medication. Try changing the pharmacy.');
      } else if (err && err.data && err.data.message) {
        this.toastr.error('Error: ' + err.data.message);
      } else {
        this.toastr.error('Error adding pharmacy: ' + JSON.stringify(err));
      }
    });
  }

  updatePharmacies() {
    // Now we validate the ROLE in the backend (PHP)
    //
    // this.Auth.validateRolesRequired({ specific_roles: [ "STAFF_MANAGER" ]})
    // .then(() => {
    this.num_processed = 0;
    this.processing = true;
    this.poll = this.$interval(this.checkFinish.bind(this), 1000);
    this.filteredResults.forEach(result => {
      if (!result.selected) {
        result.successfulUpdate = '';
      } else {
        this.MailOrderPharmacies.updatePharmacies(result.medication_id, this.selectedState, parseInt(this.selectedPharmacy.id_string)).then(response => {
          this.num_processed++;
          result.pharmacy_id = this.selectedPharmacy.pharmacy_id;
          result.name = this.selectedPharmacy.name;
          let audit = {};
          audit.user_id = this.Auth.profile.id;
          audit.action_cd = 'UPDATE';
          audit.medication_id = result.medication_id;
          audit.pharmacy_id = result.pharmacy_id;
          audit.field = 'pharmacy_id';
          audit.state_code = result.state_code;
          audit.was = result.old_pharmacy_id;
          audit.now = result.pharmacy_id; // audit.timestamp = Date.now();

          var now = new Date().getTime();
          audit.timestamp = parseInt(now / 1000);
          this.MailOrderPharmacies.audit(audit).then(() => {
            result.successfulUpdate = 'OK';
          }).catch(err => {
            result.successfulUpdate = `Error: Audit logging failed`;
          });
        }).catch(err => {
          this.num_processed++;

          if (err.status === 409) {
            // result.successfulUpdate = `Cannot set pharmacy for medication ${medication.medication_id}. No price for ${this.currentPharmacyName}`;
            result.successfulUpdate = `Error: Pharmacy medication price missing`;
          } else if (err.status === 403) {
            result.successfulUpdate = `Error: Access denied`;
          } else {
            result.successfulUpdate = 'Error: ' + JSON.stringify(err);
          }
        });
      }
    }); // })
    // .catch((err) => {
    //   if (err && err.data && err.data.message) {
    //     this.toastr.error('Error: ' + err.data.message);
    //   } else {
    //     this.toastr.error('Error validating roles: ' + JSON.stringify(err));
    //   }
    // });
  }

}

MailOrderPharmaciesController.$inject = ["$log", "$interval", "Endpoints", "MailOrderPharmacies", "MedicationPrice", "Business", "Services", "Auth", "toastr"];
angular.module('pims').controller('MailOrderPharmaciesController', MailOrderPharmaciesController);